export const createSvgRoot = (container, options) => {
  const { id, viewMode, width, height, scale } = options

  return container
    .append('svg')
    .attr('id', `svg-${viewMode}-${id}`)
    .attr('version', '1.1')
    .attr('xmlns', 'http://www.w3.org/2000/svg')
    .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
    .attr('width', width)
    .attr('height', height)
    .attr('viewBox', `0 0 ${width} ${height}`)
    .style('position', 'absolute')
    .style('left', 0)
    .style('top', 0)
    .style('transform', `scale(${scale})`)
    .style('transform-origin', 'top left')
}
